// Router
import { useLocation, useNavigate } from "react-router-dom";

// Components
import { Button, Stack, Typography } from "@mui/material";
import { MBSPaperCard } from "Common/Components";
import AvailableAppointments from "Components/Appointments/AvailableAppointments";
import { MBSPatientInfoHeader } from "Components/Users/MBS/Common";

const MBSAppointments = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const patient = state?.patient;
  const client = state?.client;
  const reasonForVisit = state?.reasonForVisit || "";
  const additionalInfo = state?.additionalInfo || "";
  const selectedLocation = state?.location || "";
  const initialSlots = state?.availableSlots || [];

  if (!patient) {
    return (
      <MBSPaperCard title="No patient selected">
        <Typography variant="body1" color="text.secondary">
          Choose a patient from search before starting a booking.
        </Typography>
        <Button variant="contained" onClick={() => navigate("/mbs/search")}>
          Back to Search
        </Button>
      </MBSPaperCard>
    );
  }

  return (
    <Stack
      spacing={2}
      sx={{
        boxSizing: "border-box",
        minHeight: "100vh",
        justifyContent: "flex-start",
      }}
    >
      <MBSPatientInfoHeader patient={patient} paper />
      <AvailableAppointments
        patient={patient}
        client={client}
        reasonForVisit={reasonForVisit}
        additionalInfo={additionalInfo}
        selectedLocation={selectedLocation}
        initialSlots={initialSlots}
        isMBS
      />
    </Stack>
  );
};

export default MBSAppointments;
